





























import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({})
export default class Checkbox extends Vue {
  @Prop({ required: true }) readonly name!: string;
  @Prop({ required: true }) readonly value!: boolean;
  @Prop({ default: false }) readonly checked!: boolean;
}
